import { createPartyRequest } from './helper';
export const getParty = createPartyRequest({
    route: '/party/parties/:partyNo',
    method: 'get',
    source: 'data',
});
